import { api } from "@/plugins/api";

const state = {
  readings: [],
};

const getters = {
  getAllReadings: (state) => state.readings,

  getReadingById: (state) => (id) => state.readings.filter((x) => x.id === id),
};

const actions = {
  async fetchAllReadings({ commit }) {
    try {
      const response = await api.get("/readings");
      const readings = response.data.data;
      console.log("readings", readings);
      commit("setReadings", readings);
      return true;
    } catch (error) {
      return false;
    }
  },
  async addReading({ commit }, reading) {
    try {
      //console.log("passed data", reading);
      const response = await api.post("/readings", reading);
      //console.log("response", response);
      commit("addReading", response.data.data);
      return true;
    } catch (error) {
      return false;
    }
  },
  async updateReading({ commit }, reading) {
    try {
      const id = reading.id;
      //console.log("passed data", reading);
      reading._method = "put";
      const response = await api.post(`/readings/${id}`, reading);
      //console.log("updated", response.data);
      commit("updateReading", response.data.data);
      return true;
    } catch (error) {
      //console.log("error", error.message);
      return false;
    }
  },
  async deleteReading({ commit }, id) {
    try {
      //const response = await api.delete(`/readings/${id}`);
      const response = await api.delete(`/readings/${id}`);
      console.log("response", response);
      if (response) {
        commit("removeReading", id);
      }
      //return response.data.message;
      return true;
    } catch (error) {
      //console.log("response", error);
      //return error.message;
      return false;
    }
  },
  async deleteAllReadings({ commit }) {
    try {
      const response = await api.delete(`/readings/delete/all`);
      console.log("del all", response);
      if (response) {
        commit("removeAllReadings");
      }
      return true;
    } catch (error) {
      return false;
    }
  },
};

const mutations = {
  setReadings(state, readings) {
    state.readings = readings;
    //console.log("mu", state.readings);
  },
  addReading(state, reading) {
    //console.log("uses is:", reading);
    state.readings.unshift(reading);
    //console.log("uses updated:", state.readings);
  },
  removeReading(state, id) {
    const index = state.readings.findIndex((reading) => reading.id == id);
    if (index !== -1) {
      state.readings.splice(index, 1);
    }
  },
  removeAllReadings(state) {
    state.readings = [];
  },
  updateReading(state, reading) {
    const id = reading.id;
    const index = state.readings.findIndex((reading) => reading.id == id);
    if (index !== -1) {
      state.readings[index] = reading;
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
